import { Grid, Typography, Box } from "@mui/material";
import transformDateToDe from "../../../../functions/transformDateToDe";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";
import IRemainingAppointment from "../interface/iRemainingAppointment";

const RemainingAppointments = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => (
  <Grid sx={{ mb: 2, gap: 2 }} xs={12}>
    <Typography
      sx={{
        fontWeight: "bold",
        mb: 1,
      }}
      variant="caption"
      component="p"
    >
      Weitere Termine
    </Typography>

    <Grid container spacing={1}>
      {appointment.remainingAppointments.map(
        (remainingAppointment: IRemainingAppointment) => (
          <Grid key={remainingAppointment.appointmentId} item xs={12} sm={6}>
            <RenderAppointment remainingAppointment={remainingAppointment} />
          </Grid>
        )
      )}
    </Grid>
  </Grid>
);

export default RemainingAppointments;

const RenderAppointment = ({
  remainingAppointment,
}: {
  remainingAppointment: IRemainingAppointment;
}): React.JSX.Element => (
  <Box>
    <Typography
      variant="body1"
      color="span"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
        gap: 1,
      }}
    >
      <KeyboardArrowRightOutlinedIcon
        sx={{
          color: "primary.main",
          fontSize: "1.2rem",
        }}
      />
      {`${transformDateToDe(
        remainingAppointment.appointmentDate
      )}, ${remainingAppointment.appointmentFromTime
        .split(":")
        .slice(0, 2)
        .join(":")} bis ${remainingAppointment.appointmentTillTime
        .split(":")
        .slice(0, 2)
        .join(":")} Uhr bei ${remainingAppointment.coachName}`}
    </Typography>
  </Box>
);
